<template>
    <div class="login">
        <img src="@/assets/images/login/logo.png" alt="" style="width: 257px;height: 50px;"/>
        <div>
            <img src="@/assets/images/login/pic.png" alt="" />
            <div class="login_box">
                <div class="login_title">
                    <!-- account mobile -->
                    <span :class="loginMethod == 'userpwd' ? 'active' : ''"
                        @click="changeLoginMethod('userpwd')">账号登录</span>
                    <el-divider  direction="vertical" style="margin: 0 30px" />
                    <span :class="loginMethod == 'mobile' ? 'active' : ''" @click="changeLoginMethod('mobile')">手机登录</span>
                </div>
                <div style="">
                    <el-form ref="loginForm" :model="loginForm" :rules="rules" class="account_bd">
                        <div v-if="loginMethod == 'userpwd'" class="animate__animated"
                            :class="loginMethod == 'userpwd' ? 'animate__backInLeft' : ''">
                            <el-form-item prop="username">
                                <el-input v-model="loginForm.username" placeholder="请输入账号" autocomplete size="large" />
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input v-model="loginForm.password" placeholder="请输入账户密码" type="password"
                                    autocomplete size="large" />
                            </el-form-item>
                            <el-form-item prop="code">
                                <el-input v-model="loginForm.code" ref="accountImgCodeInput" placeholder="请输入验证码"
                                     size="large" class="yzm_code" />
                                <img-code @change="changeImgCode" ref="mobileImgCode" :height="38" style="margin-top: -4px;"/>
                            </el-form-item>
                            <el-form-item prop="remember">
                                <el-checkbox v-model="isAutoLogin" v-show="loginMethod === 'userpwd'">记住密码</el-checkbox>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary"  class="store_btn" @click="login">
                                    商家登录
                                </el-button>
                            </el-form-item>
                        </div>
                        <div v-if="loginMethod == 'mobile'" class="animate__animated"
                            :class="loginMethod == 'mobile' ? 'animate__backInRight' : ''">
                            <el-form-item prop="mobile">
                                <el-input v-model="loginForm.mobile" placeholder="请输入手机号码" size="large" />
                            </el-form-item>
                            <el-form-item prop="code">
                                <el-input v-model="loginForm.code" ref="mobileImgCodeInput" placeholder="请输入验证码"
                                    class="yzm_code" size="large" />
                                <img-code @change="changeImgCode" ref="mobileImgCode"  :height="38" style="margin-top: -4px;"/>
                            </el-form-item>
                            <el-form-item prop="sms_code">
                                <el-input v-model="loginForm.sms_code" placeholder="请输入短信验证码" class="sms_input" 
                                    size="large" />
                                <throttle-btn key="mobile" :isValidate="isShowValidate" @validate="validateMobile"
                                    @ok="sendSms" ref="smsBtn" size="mini"/>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="store_btn"  @click="login">
                                    商家登录
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="login_box_foot">&copy; 2014-{{ new Date().getFullYear() }} <a href="https://www.91jf.com" target="_blank">91jf.com</a> All rights reserved.</div>
            </div>
        </div>
    </div>
</template>
<script>
import ImgCode from "@/components/ImgCode";
import ThrottleBtn from "@/components/ThrottleBtn";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

export default {
    name: "Login",
    components: {
        ImgCode,
        ThrottleBtn,
    },
    data() {
        return {
            rules: {
                username: [
                    {
                        required: true,
                        message: "请输入账号",
                        trigger: ["blur", "change"],
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: ["blur", "change"],
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: ["blur", "change"],
                    },
                ],
                mobile: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: ["blur", "change"],
                    },
                    { validator: this.$validate.mobile, trigger: ["blur", "change"] },
                ],
                sms_code: [
                    {
                        required: true,
                        message: "请输入动态验证码",
                        trigger: ["blur", "change"],
                    },
                ],
            },
            loginMethod: "userpwd",
            codekey: "",
            isAutoLogin: false,
            enableGetSmsCode: true,
            loginForm: {
                username: "",
                password: "",
                code: "",
                mobile: "",
                sms_code: "",
            },
            redirect: null,
            otherQuery: {},
            ticketDialog: false,
            isShowValidate: true,
        };
    },
    created() {
        this.loginForm.username = Cookies.get("username")
            ? Cookies.get("username")
            : "";
        const password = Cookies.get("password") ? Cookies.get("password") : "";
        if (password) {
            // 对密码进行解密
            this.loginForm.password = CryptoJS.AES.decrypt(
                password,
                "user123!"
            ).toString(CryptoJS.enc.Utf8);
            // 将是否记住密码置为true
            this.isAutoLogin = true;
        } else {
            this.loginForm.password = "";
        }
    },
    methods: {
        // ...mapMutations("user", ["getUserInfo"]),
        changeLoginMethod(method) {
            this.loginMethod = method;
            this.$refs.loginForm.resetFields();
        },
        changeImgCode(codekey) {
            this.codekey = codekey;
            this.loginForm.code = "";
        },
        validateMobile() {
            let {mobile}=this.loginForm
            if(!this.loginForm.code && !mobile){
                this.$message.error("请输入手机号和验证码");
                return
            }
            if(!this.loginForm.code){
                this.$message.error("请输入验证码");
                return
            }
            if(!mobile){
                this.$message.error("请输入手机号和验证码");
                return
            }
            let valid = true;
            let { codekey } = this;
            let code = `${this.loginForm.code},${codekey}`;
            this.$refs.loginForm.validateField(["mobile", "code"], (err) => {
                if (err) valid = false;
            });
            this.$util.api(
                "/common/sms_code",
                { mobile: this.loginForm.mobile, code: code, action: "login" },
                (res) => {
                    console.log(res);
                    if (res.code === 10000) {
                        if (valid) {
                            this.$refs.smsBtn.handleClick();
                        }
                    } else {
                        this.isShowValidate = true;
                        this.$message.error(res.msg);
                    }
                }
            );
        },
        sendSms() {
            const { mobile } = this.loginForm;
        },
        login() {
            let { loginMethod, codekey } = this;
            let login_type = loginMethod;
            let code = `${this.loginForm.code},${codekey}`;
            let keys =
                login_type === "userpwd"
                    ? ["username", "password", "code"]
                    : ["mobile", "sms_code", "code"];
            let valid = true;
            this.$refs.loginForm.validateField(keys, (err) => {
                if (err) valid = false;
            });
            if (valid) {
                let { loginForm, isAutoLogin } = this;
                let params = keys.reduce((obj, key) => {
                    obj[key] = loginForm[key];
                    return obj;
                }, {});
                this.$util.api(
                    "/login/account",
                    { login_type, ...params, code },
                    (res) => {
                        if (res.code == 10000) {
                            Cookies.set("ShopAdminToken",res.data.token_type + " " + res.data.access_token,{
                                expires: new Date(new Date().getTime() + res.data.expire_in * 1000), 
                                domain: '91jf.com',
                                path: '/'
                            });
                            // this.getuserxq(res.data.admin_id);
                            //是否记住账号密码
                            if (this.isAutoLogin) {
                                // Cookies.set("username", CryptoJS.SHA1(params.username));
                                //添加cookie
                                Cookies.set("username", params.username, {
                                    expires: 30,
                                });
                                //存储到cookie中 此处user123! 为秘钥
                                Cookies.set(
                                    "password",
                                    CryptoJS.AES.encrypt(params.password, "user123!"),
                                    {
                                        expires: 30, // 存储30天
                                    }
                                );
                            } else {
                                Cookies.remove("username");
                                Cookies.remove("password");
                            }
                            this.$message.success("登录成功");
                            this.$router.push('/home');
                            //跳转
                            // location.href = "/home";
                        } else {
                            this.$message.error(res.msg);
                        }
                    }
                );
            }
        },
        // getuserxq(id){
        //     this.$util.api("/admin/detail", { id: id }, (res) => {
        //         if (res.code === 10000)
        //             this.getUserInfo(res.data)
        //     });
        // },
    },
};
</script>
<style scoped>
@media only screen and (min-width: 640px) {
    .ant-input-lg {
        height: 44px;
    }

    .login {
        position: relative;
        margin-top: 0;
        background: url("~@/assets/images/login/bg.png") no-repeat 0 0/100% 100%;
        width: 100vw;
        height: 100vh;
        z-index: 6;
    }

    .login>img {
        position: absolute;
        top: 11%;
        left: 15%;
        z-index: 7;
    }

    .login>div:nth-child(2) {
        position: relative;
        top: 24%;
        /* display: flex;
    justify-content: space-between; */
        z-index: 6;
    }

    .login>div:nth-child(2)>img {
        position: relative;
        z-index: 1;
        width: 49%;
        height: 40%;
        margin-left: 10%;
        margin-right: 2%;
        margin-bottom: 3%;
    }

    .login>div:nth-child(2) .login_box {
        position: fixed;
        top: 20%;
        right: 11%;
        border-radius: 10px;
        box-shadow: 1px 2px 9px 4px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        background: #fff;
        display: block;
        width: 430px;
        height: 528px;
        /* background: red; */
        z-index: 55;
    }

    .login::after {
        content: "";
        display: block;
        width: 80%;
        height: 100vh;
        position: absolute;
        left: 0;
        bottom: 0;
        background: radial-gradient(circle farthest-side at bottom left,
                #fff -5%,
                transparent 162%);
        z-index: 1;
    }

    .login_box_foot {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 41px;
        background: #f6f8fb;
        border-radius: 0px 0px 10px 10px;
        text-align: center;
    }

    .login_box>>>.login_title {
        display: flex;
        font-size: 18px;
        align-items: center;
        margin-top: 60px;
        justify-content: center;
        color: #cccccc;
    }

    .login_box>>>.login_title span {
        color: #666666;
        cursor: pointer;
    }

    .login_box>>>.login_title .active {
        width: 72px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #2676ff;
        line-height: 25px;
        font-weight: 600;
    }

    /* form */

    .account_bd {
        width: 330px;
        margin: 40px auto 0;
    }

    .account_bd form {
        overflow: hidden;
        height: 365px !important;
    }

    .btn_sms_code {
        display: inline-block;
        width: 114px;
        height: 39px;
        line-height: 39px;
        text-align: center;
        border: 1px solid #2676ff;
        font-weight: 400;
        border-radius: 4px;
        background: #ffffff;
        font-size: 14px;
        color: #2676ff;
        cursor: pointer;
        margin-left: 20px;
    }

    .login_box>>>.ant-form-item-children {
        display: flex;
    }

    .yzm_code{
        width: 190px;
    }
    .store_btn{
        width: 330px;
        height: 40px;
    }

    .sms_input{
        width: 190px;
    }
}

@media only screen and (max-width: 640px) {
    .ant-input-lg {
        height: 44px;
    }

    .login {
        position: relative;
        margin-top: 0;
        background: url("~@/assets/images/login/bg.png") no-repeat 0 0/100% 100%;
        width: 100vw;
        height: 100vh;
        z-index: 6;
    }

    .login>img {
        position: absolute;
        top: 11%;
        left: 50%;
        z-index: 7;
        transform: translateX(-50%);
        width: 160px !important;
        height: 32px !important;
    }

    .login>div:nth-child(2) {
        position: relative;
        top: 24%;
        /* display: flex;
    justify-content: space-between; */
        z-index: 6;
    }

    .login>div:nth-child(2)>img {
        position: relative;
        z-index: 1;
        width: 49%;
        height: 40%;
        margin-left: 10%;
        margin-right: 2%;
        margin-bottom: 3%;
        display: none;
    }

    .login>div:nth-child(2) .login_box {
        position: fixed;
        top: 20%;
        /* right: 11%; */
        left: 50%;
        transform: translateX(-50%);
        border-radius: 10px;
        box-shadow: 1px 2px 9px 4px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        background: #fff;
        display: block;
        /* width: 430px; */
        height: 75vh;
        width: 85%;
        margin: 0 auto;
        /* background: red; */
        z-index: 55;
    }

    .login::after {
        content: "";
        display: block;
        width: 100%;
        height: 100vh;
        position: absolute;
        left: 0;
        bottom: 0;
        background: radial-gradient(circle farthest-side at bottom left,
                #fff -5%,
                transparent 162%);
        z-index: 1;
    }

    .login_box_foot {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 41px;
        background: #f6f8fb;
        border-radius: 0px 0px 10px 10px;
        text-align: center;
    }

    .login_box>>>.login_title {
        display: flex;
        font-size: 18px;
        align-items: center;
        margin-top: 60px;
        justify-content: center;
        color: #cccccc;
    }

    .login_box>>>.login_title span {
        color: #666666;
        cursor: pointer;
    }

    .login_box>>>.login_title .active {
        width: 72px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #2676ff;
        line-height: 25px;
        font-weight: 600;
    }

    /* form */

    .account_bd {
        width: 86%;
        margin: 40px auto 0;
    }

    .account_bd form {
        overflow: hidden;
        height: 365px !important;
    }

    .btn_sms_code {
        display: inline-block;
        width: 114px;
        height: 39px;
        line-height: 39px;
        text-align: center;
        border: 1px solid #2676ff;
        font-weight: 400;
        border-radius: 4px;
        background: #ffffff;
        font-size: 14px;
        color: #2676ff;
        cursor: pointer;
        margin-left: 20px;
    }

    .login_box>>>.ant-form-item-children {
        display: flex;
    }
    .yzm_code{
        width: 60%;
    }
    .img_code{
        margin-left: 5%;
        width: 33%;
    }

    .store_btn{
        position: absolute;
        width: 85%;
        height: 40px;
        left: 50%;
        transform: translateX(-50%);
    }

    .sms_input{
        width: 60%;
    }

    .btn_send_sms{
        min-width: 15% !important;
        margin-left: 5% !important;
        padding: 7px 3% !important;
    }
}

</style>